import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FormControl, InputLabel, RadioGroup, Radio, FormControlLabel, FormHelperText } from 'material-ui';

class RadioButtonComponent extends Component {

    render() {
        const { classes, error } = this.props;
        return (
            <FormControl className={classes.formControl} disabled={this.props.disabled} error={error && error !== "" ? true : false}>
                <InputLabel shrink={true} htmlFor={this.props.name}>{this.props.label}</InputLabel>
                <RadioGroup
                    aria-label={this.props.name}
                    name={this.props.name}
                    className={classes.group}
                    value={this.props.value}
                    onChange={this.props.setValue}
                    id={this.props.id}
                >
                    {this.props.options.map((option) => {
                        return <FormControlLabel key={`radio_${this.props.id}_${option.value}`} value={option.value} control={<Radio color="secondary" />} label={option.label} />
                    })}
                </RadioGroup>
                {error && error !== "" && <FormHelperText>{error}</FormHelperText>}
            </FormControl>
        );
    }
}

const styles = theme => ({
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "70%"
    },
    group: {
        marginTop: "1rem"
    }
});


export default withStyles(styles)(RadioButtonComponent);



// WEBPACK FOOTER //
// ./src/components/displayComponents/RadioButtonComponent.js